var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1155_3227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.77162 1.6292C5.79317 1.59007 5.82482 1.55744 5.86327 1.53471C5.90173 1.51199 5.94558 1.5 5.99025 1.5C6.03492 1.5 6.07877 1.51199 6.11723 1.53471C6.15568 1.55744 6.18733 1.59007 6.20888 1.6292L7.68237 4.42644C7.71751 4.49121 7.76655 4.5474 7.82598 4.59097C7.8854 4.63454 7.95374 4.66441 8.02608 4.67844C8.09842 4.69247 8.17297 4.69031 8.24438 4.67211C8.31579 4.65391 8.38228 4.62013 8.43908 4.57319L10.5739 2.7443C10.6149 2.71097 10.6654 2.6915 10.7182 2.6887C10.7709 2.68589 10.8232 2.6999 10.8675 2.7287C10.9118 2.7575 10.9458 2.79961 10.9646 2.84897C10.9834 2.89833 10.9861 2.95238 10.9723 3.00336L9.55767 8.11765C9.5288 8.22231 9.46659 8.3147 9.38048 8.38081C9.29437 8.44693 9.18905 8.48316 9.08049 8.48403H2.90051C2.79186 8.48327 2.68643 8.44708 2.60022 8.38096C2.51401 8.31484 2.45172 8.22239 2.42282 8.11765L1.00873 3.00386C0.994881 2.95288 0.997562 2.89883 1.01639 2.84947C1.03522 2.80011 1.06922 2.758 1.1135 2.7292C1.15779 2.7004 1.21007 2.68639 1.26282 2.6892C1.31557 2.692 1.36607 2.71147 1.40705 2.7448L3.54142 4.57369C3.59822 4.62063 3.66471 4.65441 3.73612 4.67261C3.80753 4.69081 3.88208 4.69297 3.95442 4.67894C4.02676 4.66491 4.09509 4.63504 4.15452 4.59147C4.21395 4.5479 4.26299 4.49171 4.29813 4.42694L5.77162 1.6292Z",
    stroke: "#E17100",
    strokeWidth: 0.9983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49609 10.4805H9.48419",
    stroke: "#E17100",
    strokeWidth: 0.9983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1155_3227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9796,
    height: 11.9796,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.d08368eea6de0408ab1c9fd969a0f4af.svg";
export { ForwardRef as ReactComponent };